import { render } from "./Stats.vue?vue&type=template&id=6bd3153f&scoped=true"
import script from "./Stats.js?vue&type=script&lang=js"
export * from "./Stats.js?vue&type=script&lang=js"

import "./Stats.vue?vue&type=style&index=0&id=6bd3153f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bd3153f"]])

export default __exports__